"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusTagType = void 0;
var StatusTagType;
(function (StatusTagType) {
    StatusTagType["VERIFIED"] = "VERIFIED";
    StatusTagType["PENDING"] = "PENDING";
    StatusTagType["EXPIRED"] = "EXPIRED";
})(StatusTagType = exports.StatusTagType || (exports.StatusTagType = {}));



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/StatusTag/StatusTagProps.js
// module id = 673
// module chunks = 8